import React, { useState } from 'react';
import ActionBar from '../layout/ActionBar';
import BulkIngest from './slideout/BulkIngest';
import BulkIngestedBatchesList from './components/BulkIngestedBatchesList';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';

function BulkIngested() {
  const currentUser = useAppSelector((state) => state.auth);
  const bulkTransactions = useAppSelector((state) => state.bulkTransactions);

  const [reload, setReload] = useState<any>();
  const { t } = useTranslation();
  usePageTitle(['Bulk ingested', 'Keys']);
  const [bulkIngestSlideoutOpen, setBulkIngestSlideoutOpen] = useState(false);

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setBulkIngestSlideoutOpen(true)}
          text={t('Bulk upload keys')}
        />
      </ActionBar>
      <BulkIngestedBatchesList
        reload={reload}
        bulkTransactions={bulkTransactions}
        currentUser={currentUser}
      />

      <SlidingPane
        isOpen={bulkIngestSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setBulkIngestSlideoutOpen(false)}
      >
        <BulkIngest
          done={() => {
            setReload(new Date());
            setBulkIngestSlideoutOpen(false);
          }}
          cancel={() => setBulkIngestSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default BulkIngested;
